var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgC(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "89.640671mm",
    height: "93.591774mm",
    viewBox: "0 0 89.64067 93.591774",
    id: "svg814",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs811"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-115.31123,-96.087413)"
  }, /*#__PURE__*/React.createElement("g", {
    "aria-label": "C",
    id: "text1719",
    style: {
      fontWeight: "bold",
      fontSize: "123.472px",
      fontFamily: "'Neue Haas Grotesk Text Pro'",
      InkscapeFontSpecification: "'Neue Haas Grotesk Text Pro Bold'",
      fill: "#a9bacd",
      strokeWidth: 0.264583,
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 204.33454,132.38818 c -2.34597,-22.84232 -17.53303,-36.300767 -44.69687,-36.300767 -24.81787,0 -44.32644,17.903437 -44.32644,46.672417 0,28.89245 17.77996,46.91936 47.1663,46.91936 23.45968,0 39.88146,-13.82886 42.47437,-36.79466 h -28.02815 c -1.11124,8.51957 -5.55624,15.06359 -14.94011,15.06359 -14.81664,0 -17.53302,-11.72984 -17.53302,-24.20051 0,-17.16261 6.1736,-25.92912 16.42177,-25.92912 9.13693,0 14.94012,5.30929 15.80442,14.56969 z",
    style: {
      fontWeight: 900,
      fontFamily: "'Helvetica LT Std'",
      InkscapeFontSpecification: "'Helvetica LT Std Heavy'",
      fill: "#a9bacd",
      fillOpacity: 1
    },
    id: "path1771"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgC);
export default __webpack_public_path__ + "static/media/C.15352b12f68c40e1ece849f41463c32b.svg";
export { ForwardRef as ReactComponent };